'use client'

import { usePathname } from 'next/navigation'
import Image from 'next/image'
import { Inner } from '@/widget/container/ui/Inner'
import { FOOTER } from '@/shared/utils/const'

export default function FooterPC() {
    const pathname = usePathname()
    if (pathname?.startsWith('/v2/trade')) {
        return null
    }

    return (
        <footer className="pt-[30px] pb-[30px] bg-header-nav border-t-4  border-solid border-t-[#32363D] border-l-0 border-r-0 border-b-0 box-border">
            <Inner type="pc" className="flex justify-between align-center h-[43px]">
                <h5>
                    <Image src={FOOTER.logo} width={243} height={38} alt="footer" unoptimized />
                </h5>
                <div className="relative text-right pl-[100px]">
                    <a href="https://super-trader.gitbook.io/termsansconditions" target="_blank"
                        className='absolute left-[0px] top-[0px] text-[16px] font-medium underline color-gray'>
                        이용약관
                    </a>
                    <p className="text-[16px] font-medium tracking-[-0.4px]">고객센터 : SuperTrader.Manager@gmail.com</p>
                    <p className="text-[12px] font-medium tracking-[-0.3px]">Copyright&copy;2023 SUPER TRADER.All rights reserved</p>
                </div>
            </Inner>
        </footer>
    )
}


